<div class="container">
    <input type="checkbox" [checked]="checked" (click)="selectChoice(checkboxValue)" [id]="id" >
    <span  [ngClass]="{'checkmark': true }" ></span>  
</div>